import './RightMenuDesign.scss';
import { CSSTransition } from 'react-transition-group';
import { Divider } from 'antd';
import { useRef } from 'react';
import { Drawer } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const RightMenuDesign = ({ open, header, content, classNames, styles }) => {
  return (
    <CSSTransition
      in={open === false || open === undefined || open === null ? false : true}
      classNames="expand"
      timeout={300}
      appear
      unmountOnExit
    >
      <div
        className={
          'right-menu-design flex flex-col justify-start items-center absolute right-16 top-0 bottom-16 rounded-[8px] ' +
          classNames?.root
        }
        style={{
          backgroundColor: '#F7F7F7',
          ...(styles?.root ?? {}),
        }}
      >
        <div
          className={
            'right-menu-design-header bg-fills-white ' + classNames?.header
          }
          style={styles?.header}
        >
          {header}
        </div>
        <Divider type="horizontal" style={{ margin: 0 }} />
        <div
          className={'right-menu-design-body ' + classNames?.content}
          style={styles?.content}
        >
          {content}
        </div>
      </div>
    </CSSTransition>
  );
  // const containerRef = useRef(null);

  // return (
  //   <div
  //     ref={containerRef}
  //     className={cn(
  //       '[&_.ant-drawer]:absolute absolute right-16 top-0 bottom-16',
  //       classNames?.root
  //     )}
  //     style={styles?.root}
  //   >
  //     <Drawer
  //       title={header}
  //       placement="right"
  //       closable={false}
  //       onClose={() => {}}
  //       open={open}
  //       width={280}
  //       classNames={{
  //         ...classNames,
  //         body: cn('!p-0 self-stretch flex flex-col', classNames?.body),
  //         header: cn(
  //           '[&_.ant-drawer-title]:flex [&_.ant-drawer-title]:items-center [&_.ant-drawer-title]:justify-between self-stretch bg-fills-white',
  //           classNames?.header
  //         ),
  //         wrapper: cn('rounded-[8px] !duration-400', classNames?.wrapper),
  //         content: cn('rounded-[8px]', classNames?.content),
  //         mask: cn('bg-transparent rounded-[8px]', classNames?.mask),
  //       }}
  //       styles={styles}
  //       getContainer={() => containerRef.current}
  //     >
  //       {content}
  //     </Drawer>
  //   </div>
  // );
};

export default RightMenuDesign;
